import React from 'react';
import { Box } from '@mui/material';
import SideBar from '../../uiParts/menu/SideBar';
import StaffEditCard from '../../uiParts/card/StaffEditCard';
import { useAuthRedirect } from '../../../hooks/useAuthRedirect';
import MetaTitle from '../../utils/MetaTitle';
import { usePageLayout } from '../../../hooks/usePageLayout';

const StaffEdit = (): React.ReactElement => {
  // 未認証ならログイン画面へ退避する（元URLは ?redirect= で引き継ぐ。#3203）
  useAuthRedirect();
  const { sideBarCollapsed, toggleSidebar, styles: layoutStyles } = usePageLayout();

  return (
    <Box sx={layoutStyles.pageWrapper}>
      <MetaTitle />
      <Box sx={[layoutStyles.sidebar, sideBarCollapsed && layoutStyles.sidebarCollapsed]}>
        <SideBar collapsed={sideBarCollapsed} onToggle={toggleSidebar} />
      </Box>
      <Box
        sx={[
          layoutStyles.pageContent,
          sideBarCollapsed && layoutStyles.pageContentCollapsed,
          {
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
          },
        ]}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: '600px',
            '@media screen and (max-width:960px)': {
              padding: '24px 16px 80px 16px',
            },
          }}
        >
          <StaffEditCard />
        </Box>
      </Box>
    </Box>
  );
};
export default StaffEdit;
